var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Minus_icon",
    "data-name": "Minus icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.947,
    height: 16.947,
    viewBox: "0 0 16.947 16.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M333.049,261.31a8.474,8.474,0,1,1-8.474-8.474,8.474,8.474,0,0,1,8.474,8.474",
    transform: "translate(-316.102 -252.836)",
    fill: "#d2dce9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M399.174,327.471h-7.22a.7.7,0,0,0,0,1.4h7.22a.7.7,0,0,0,0-1.4",
    transform: "translate(-386.856 -319.642)",
    fill: "#95a7c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusicon);
export default __webpack_public_path__ + "static/media/Minus icon.7ce5463e62a54ab39d4928cf161f6d7f.svg";
export { ForwardRef as ReactComponent };